import ProductModel from "shop/ProductModel"
import SessionModel from "shop/SessionModel"

const API_BASE = process.env.REACT_APP_API
const CMS_BASE = process.env.REACT_APP_CMS || `${API_BASE}/wp`

const config = {
    BASE: API_BASE,
    API: API_BASE + "/shop/rest/",
    CMS: CMS_BASE + "/wp-json/wp/v2/",
    MEDIA: API_BASE + "/shop/rest/data/images/",
    CMS_BASE: CMS_BASE,

    MIN_ORDER_VALUE: false,
    pageSize: 64,

    b2cLink: false,
    //ENABLE FORMULARS
    customer_registration: true,
    customer_enabling: false,
    costcentre_editable: true,

    model: {
        ProductModel,
        SessionModel
    }
}


console.log( "BASE CONF", {config}, process.env )
export default config



// WEBPACK FOOTER //
// ./src/theme/oehme/config.js